<template>
<v-card>
  <v-card-title class='overline' >
  </v-card-title>
  <!-- <appointment-picker multiple :with-select-action='true' >
  </appointment-picker> -->
    <v-btn :href='oauthUrl' >Connect Zoom</v-btn>
    <v-btn :disabled='!oAuthCode' @click='connectToZoom' >Authenticate</v-btn>
    {{oAuthCode}}

</v-card>
</template>
<script>
/*
 * 1. Has integration?
 *   no  -> createZoomIntegration
 *   yes ->
 *     has appointments?
 *       no -> appointment picker
 *       yes -> make offline
 */
// import AppointmentPicker from '@/components/pickers/AppointmentPicker'

export default {
  name: 'ZoomMakeOnline',
  props: {
    appointments: { type: Array, required: false }
  },
  // components: {AppointmentPicker},
  data () {
    return {
      reqId: 'integrations-list',
      connectReqId: 'integrations-connect-zoom'
    }
  },
  mounted () {
    if (this.oAuthCode) {
      this.connectToZoom()
    }
  },
  computed: {
    oauthUrl () {
      return 'https://zoom.us/oauth/signin?client_id=3vVWc4sHSTWQkXJILK64A&redirect_uri=https%3A%2F%2Fdeploy-preview-30--app-next.netlify.com%2F%23%2Ftest&response_type=code'
    },
    integrations () {
      let lookups = this.store.getters.lookups
      if ('integrations' in lookups) {
        return lookups.find((integration) => {
          return integration.title === 'Zoom'
        })
      }
      return null
    },
    integrationsRequest () {
      return this.store.getters.getRequestById(this.reqId, true)
    },
    oAuthCode () {
      let search = window.location.search
      let bits = search.split('=')
      if (bits && bits.length === 2) {
        return bits[1]
      }
      return null
    }
  },
  methods: {
    getIntegrations () {
      this.$appointmentguru.resource('practitioner.integrations').list()
    },
    connectToZoom () {
      let data = {
        auth_code: this.oAuthCode
      }
      console.log(data)
      this.$appointmentguru
        .resource('practitioner.integrations.zoom')
        .id(this.connectReqId)
        .create(data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?05f68e4c